import { useMutation } from "@tanstack/react-query";
import { useCallback, useContext } from "react";
import { OrderRepositoryImpl } from "../../domain/orderRepositoryImpl/OrderRepositoryImpl";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";
import { queryKey as getOrderSummaryForCheckout } from "./useGetOrderSummaryForCheckout";

const orderRepository = OrderRepositoryImpl.getInstance();

const useMoveStockoutsToWishlist = (onMovedStockOutsToWishlist: () => void) => {
  const {
    session: { auth },
    apiUrl,
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const mutation = useMutation(
    {
      mutationFn: async () => {
        const order = await orderRepository.getOrder(auth, apiUrl);

        if (order.items.some((item) => item.available === false)) {
          await orderRepository.moveStockOutsToWishlist(auth, apiUrl);
          onMovedStockOutsToWishlist();
        }
      },
      onSuccess: () => {
        queryClient?.invalidateQueries({
          queryKey: [getOrderSummaryForCheckout],
        });
      },
    },
    queryClient,
  );

  const moveStockoutsToWishlist = useCallback(() => {
    mutation.mutate();
  }, [mutation]);

  return moveStockoutsToWishlist;
};

export { useMoveStockoutsToWishlist };
